import { ofType } from "redux-observable";
import { from } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { TypeActionGrantRewards } from "../../grant-rewards/actionGrantRewards";
import { TypeGrantRewards } from "../../grant-rewards/TypeGrantRewards";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionModalSwapLast } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
export var epicShopGrantRewardReceived = function (action$) {
    return action$.pipe(ofType(TypeActionGrantRewards.Received), filter(function (action) {
        return action.rewardsType === TypeGrantRewards.Shop &&
            action.rewards != undefined &&
            action.rewards.resourceRewards != undefined;
    }), switchMap(function (action) {
        return from([
            actionInventoryInfoAddResource(action.rewards.resourceRewards),
            actionModalSwapLast(IdModal.PaymentReward),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopGrantRewardReceived.ts
// module id = 2335
// module chunks = 3